import {
  ogType,
  twitterHandle,
  seoIndexString,
  seoNoIndexString,
} from '@constants/seo'
import { logger } from '@core/logger'
import type { Seo } from '@customTypes/generated/contentfulGraphqlAPI'

export type PageMeta = Pick<
  Seo,
  'pageTitle' | 'ogTitle' | 'seoDescription' | 'ogDescription'
> & { shouldIndex: boolean; ogUrl: string; ogImage?: { url?: string | null } }

export const generatePageMeta = (pageMeta: PageMeta) => {
  if (!pageMeta.pageTitle) {
    logger.warn('MISSING_PAGE_TITLE', {
      url: pageMeta.ogUrl,
    })
  }

  return [
    { title: pageMeta?.pageTitle },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover',
    },
    { property: 'description', content: pageMeta?.seoDescription },
    { property: 'og:type', content: ogType },
    {
      property: 'og:title',
      content: pageMeta?.ogTitle,
    },
    {
      property: 'og:description',
      content: pageMeta?.ogDescription,
    },
    {
      property: 'og:image',
      content: pageMeta?.ogImage?.url,
    },
    {
      property: 'og:url',
      content: pageMeta.ogUrl,
    },
    {
      property: 'twitter:title',
      content: pageMeta?.ogTitle,
    },
    {
      property: 'twitter:description',
      content: pageMeta?.ogDescription,
    },
    {
      property: 'twitter:image',
      content: pageMeta?.ogImage?.url,
    },
    {
      property: 'twitter:site',
      content: twitterHandle,
    },
    {
      property: 'robots',
      content: !pageMeta?.shouldIndex ? seoNoIndexString : seoIndexString,
    },
  ].filter(metaEntry => {
    // Remove empty entries
    return metaEntry.title || metaEntry.content !== undefined
  })
}
